module.exports = __webpack_public_path__ + "static/media/Cabinet2_After.724aa31c.jpg";